<template>
    <div>
        <p v-if="isLoading">Loading...</p>
        <template v-else>
            <div class="row">
                <div class="col-sm-12">
                    <CategoryBarChart class="shadow p-3 mb-5 bg-white rounded" :chart-data="userDashboard.userFormResultsByCategory"/>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <EmployeePieChart class="shadow p-3 mb-5 bg-white rounded" :chart-data="userDashboard.userFormResults"/>
                </div>
                <div class="col-sm-6">
                    <UserGroupBarChart class="shadow p-3 mb-5 bg-white rounded" :chart-data="userDashboard.userFormResultsByUserGroup"/>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    import EmployeePieChart from './charts/EmployeePieChart';
    import UserGroupBarChart from './charts/UserGroupBarChart';
    import CategoryBarChart from './charts/CategoryBarChart';
    import * as categoryStoreTypes from "../../vuex/modules/category/category.store-types";

    export default {
        name: 'manager-dashboard',
        components: {EmployeePieChart, UserGroupBarChart, CategoryBarChart},
        async created() {
            await this.getUserDashboard({companyId: this.currentUser.company._id, userId: this.currentUser.userId});
        },
        computed: {
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            ...mapGetters('user', {
                /** @type {boolean|*} */
                isLoading: categoryStoreTypes.GET_IS_LOADING,
                /** @type {array|*} */
                userDashboard: userStoreTypes.GET_USER_DASHBOARD,
            }),
        },
        methods: {
            ...mapActions('user', {
                /** @type {function|*} */
                getUserDashboard: userStoreTypes.ACTION_GET_USER_DASHBOARD,
            }),
        }
    }
</script>